// import type { ProductConfig } from "../mistral"
import img1 from "./itens-de-seguranca/1.png";
import img2 from "./itens-de-seguranca/2.gif";
import img3 from "./itens-de-seguranca/3.png";
import img4 from "./itens-de-seguranca/4.png";
import img5 from "./itens-de-seguranca/5.png";
import { PublicHash } from "./public-hash";
import { QrCodeQueryLoading } from "./qr-code-query-loading";

export const imagens = [img1, img2, img3, img4, img5];

import type { ProductConfig } from "../type";
import FavIcon from "./assets/favicon.png";
import Seal from "./assets/seal.webp";
import LandingPage from "./LandingPage";
import { SealMask } from "./seal-mask";

export const validadorPrimiConfig: ProductConfig = {
	defaultLanguage: "en",
	product: {
		name: "Primi",
		domains: [
			"validador.primi.com.br",
			"www.validador.primi.com.br",
			"validador.homol.primi.com.br",
			"www.validador.homol.primi.com.br",
		],
		description:
			"Gerencie os selos de autenticidade do seu produto com numeração sequencial. Cada produto possui seu selo único com controle de lotes numerados.",
	},
	LandingPage,
	Logo: "/primi-logo.png",
	SealMask,
	QrCodeQueryLoading,
	FavIcon,
	Seal,
	PublicHash,
	theme: {
		colors: {
			cssVariables: {
				"--primary": "oklch(0.46 0.12 235)",
			},

			fallback: {
				primary: "blue-900",
				secondary: "amber-300",
				accent: "orange-400",
				background: "from-blue-50 to-amber-50",
				cardBackground: "from-amber-50 to-orange-50",
			},
		},
		fonts: {
			heading: "font-bold",
			body: "font-normal",
		},
	},
	securityItems: [
		{
			title: "QR Code com impressão especial",
			description:
				"Verifique se o QR Code muda de cor (entre tons dourados) ao mudar o ângulo de visão do selo. É possível sentir um leve relevo. Essas características, obtidas com tintas de segurança, indicam autenticidade. Um QR Code com cor estática pode sinalizar falsificação.",
			image: imagens[0],
		},
		{
			title: "Holografia de segurança",
			description:
				"A holografia no selo é exclusiva e de alta segurança. Ela deve apresentar alternância entre as palavras “VÁLIDO” , “ORIGINAL” e “OK” e no mesmo padrão de layout do exemplo acima.",
			image: imagens[1],
		},
		{
			title: "Numeração Microperfurada",
			description:
				"Cada selo possui uma codificação única impressa por um equipamento especial a laser sem uso de tintas, na tonalidade branca. Confira se o código é o mesmo que aparece na validação e se é composto por pequenos furos.",
			image: imagens[2],
		},
		{
			title: "Fundos Anticópias",
			description:
				"Os fundos anticópias apresentam padrões variados e complexos, e podem ser constituído por linhas contínuas e bem definidas em formas geométricas variadas. Para garantir que o selo não é uma reprodução, compare o fundo do selo que você está verificando com a imagem de referência acima. Linhas falhas, ou desenhos diferentes, podem ser um indício de fraude.",
			image: imagens[3],
		},
		{
			title: "Impressão Opticamente Variável",
			description:
				"Impressão com tintas especiais de segurança. Verifique se as estrelas apresentam brilho e cintilância conforme você movimenta o selo ou altera o ângulo de visão. Além disso, toque a área impressa para sentir um leve relevo.",
			image: imagens[4],
		},
	],
	settings: {
		enableQRCode: true,
		enableMap: true,
		enableReports: true,
		maxSealsPerBatch: 5000,
		enablePublicHash: false,
	},
};
